import React, { useId, useState } from "react";

// Reusable accordion for a single "Part" that renders its sections dynamically
// Props:
// - part: { id, title, sections: [{ id, title, content }] }
// - onSectionClick: (section) => void
// - defaultOpen: boolean
const AccordionPart = ({ part, onSectionClick, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const panelId = useId();
  const buttonId = `${panelId}-button`;
  const contentId = `${panelId}-content`;

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <button
        type="button"
        id={buttonId}
        onClick={() => setIsOpen((v) => !v)}
        className="w-full flex items-center justify-between px-4 sm:px-5 py-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
        aria-expanded={isOpen}
        aria-controls={contentId}
      >
        <span className="text-sm sm:text-base font-medium text-gray-800">
          {part.title}
        </span>
        <svg
          className={`w-5 h-5 text-gray-700 transition-transform ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div
          id={contentId}
          role="region"
          aria-labelledby={buttonId}
          className="px-4 sm:px-5 pb-4 sm:pb-5"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {part.sections.map((section) => (
              <button
                key={section.id}
                type="button"
                onClick={() => onSectionClick(section)}
                className="text-left px-3 py-3 rounded-md border border-gray-200 hover:border-blue-400 hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 text-gray-800"
              >
                <span className="text-sm font-medium">{section.title}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AccordionPart;
